<script>
import {defineComponent} from 'vue'

// const selectedTokenMint = defineModel()
export default defineComponent({
    name: "TokenList",
    data() {
        return {
            tokenModalVisible: false,
            tokens: [],
            search: '',
        }
    },
    props: {
        list: {
            default: 'strict',
            type: String,
            required: true
        },
        btnClass: {
            default: 'btn btn-primary',
            type: String,
            required: false
        },
        sortValues: {
            default: {},
            type: Object,
            required: false
        },
        sortValuePrefix: {
            default: '',
            type: String,
            required: false
        },
        sortValueSuffix: {
            default: '',
            type: String,
            required: false
        },
        featuredTokens: {
            default: [],
            type: Array,
            required: false
        }
    },
    methods: {
        async getTokens() {
            const response = await axios.get('/tokenMeta/' + this.list)
            this.tokens = response.data
        },
        selectToken(row) {
            this.$emit('selectToken', row)
            this.selectedTokenMint = row.mint
            this.tokenModalVisible = false
        }
    },
    mounted() {
        this.getTokens()
    },
    computed: {
        selectedToken() {
            return this.tokens.find(token => token.mint === selectedTokenMint)
        },
        filteredTokens() {
            return this.tokens.filter(token => {
                return token.symbol.toLowerCase().includes(this.search.toLowerCase()) ||
                    token.address.toLowerCase().includes(this.search.toLowerCase()) ||
                    token.name.toLowerCase().includes(this.search.toLowerCase()) ||
                    token.description.toLowerCase().includes(this.search.toLowerCase())
            })
        },
        sortedTokens() {
            // we want a way to highlight specific tokens
            // then tokens should be sorted by another dimension passed in as a prop
            // this could be the APY, the user's balance etc
            let sorted = this.filteredTokens.sort((a, b) => {
                let aVal = this.sortValues[a.mint] || 0
                let bVal = this.sortValues[b.mint] || 0
                return bVal - aVal
            })
            // now lets sort by whether the token is in this.featuredTokens
            return sorted.sort((a, b) => {
                let aVal = this.featuredTokens.includes(a.mint) ? 1 : 0
                let bVal = this.featuredTokens.includes(b.mint) ? 1 : 0
                return bVal - aVal
            })
            // todo: sort and featured by prop, or using a method?

        }

    }


})
</script>

<template>
    <button :class="btnClass"
            @click="tokenModalVisible = true"
            >
        <img :src="selectedToken.imageUri" :alt="selectedToken.symbol">
        {{selectedToken.symbol}}
    </button>
    <el-dialog v-model="tokenModalVisible" title="Select Token" >
        <!-- search bar -->
        <div class="form-group">
            <input type="text" class="form-control" v-model="search" placeholder="Search by token or address">
        </div>

        <el-table :data="tokens" style="width: 100%" highlight-current-row @current-change="selectToken">
            <el-table-column
                prop="imageUri"
                label="Image">
                <template slot-scope="scope">
                    <img :src="scope.row.imageUri" :alt="scope.row.symbol">
                </template>
            </el-table-column>
            <el-table-column
                prop="symbol"
                label="Symbol"
                width="180">
            </el-table-column>
            <el-table-column
                prop="name"
                label="Name">
            </el-table-column>

            <el-table-column
                label="Select">
                <template slot-scope="scope">
                    <el-button @click="selectedTokenMint = scope.row.mint">Select</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<style scoped>

</style>
